const allHeaderOverlays = document.querySelectorAll(".header__primary-nav .overlay");

allHeaderOverlays.forEach((overlay) => {
    overlay.addEventListener("click", function() {
        document.querySelector('.header__menu-disclosure[open] summary').click();
    })
});



document.addEventListener("DOMContentLoaded", function() {
    const videos = document.querySelectorAll('video');

    if (videos.length > 0) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const video = entry.target;
                if (entry.isIntersecting) {
                    setTimeout(function() {
                        video.closest("video-media").setAttribute("loaded", true)
                        if (video.readyState >= 2) { // Check if video is ready to play
                            video.play().catch(error => {
                                console.log('Autoplay failed:', error);
                                // Optionally, you can add a fallback here to prompt user interaction
                            });
                        }
                    }, 1000);
                } else {
                    video.closest("video-media").removeAttribute("loaded")
                    video.pause();
                }
            });
        });
    
        videos.forEach(video => {
            observer.observe(video);
        });
    }


    if (document.body.classList.contains('template-product')) {
        console.log('The body has the class "template-product".');

        const reviews_anchor_link = document.querySelector('a[href="#stamped-main-widget"]');
        const related_prods_anchor_link = document.querySelector('a[href="#related-products"]');

        function scrollToElement(element) {
            element.addEventListener('click', function(e) {
                console.log('The body was clicked.', e.target);
                // if (e.target.matches('a[href="#stamped-main-widget"]')) {
                    e.preventDefault(); // Prevent the default anchor behavior
            
                    // Get the hash, e.g., "#myDestinationAnchor"
                    const targetSelector = element.hash;
                    const target = document.querySelector(targetSelector);
    
                    console.log(targetSelector, target);
            
                    if (target) {
                        const initialOffset = target.getBoundingClientRect().top + window.pageYOffset;
            
                        window.scrollTo({
                            top: initialOffset,
                            behavior: 'smooth'
                        });
            
                        const duration = 2000;
                        const startTime = performance.now();
            
                        function step(currentTime) {
                            const elapsedTime = currentTime - startTime;
                            const currentOffset = target.getBoundingClientRect().top + window.pageYOffset;
            
                            if (elapsedTime < duration) {
                                if (Math.abs(currentOffset - initialOffset) > 1) {
                                    window.scrollTo({
                                        top: currentOffset,
                                        behavior: 'smooth'
                                    });
                                }
                                requestAnimationFrame(step);
                            }
                        }
            
                        requestAnimationFrame(step);
                    }
                // }
            });
        }

        scrollToElement(reviews_anchor_link);
        scrollToElement(related_prods_anchor_link);
    }

});